var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNotificationActive = function SvgIconNotificationActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-notification-active_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M18.452 14.648v-3.8c0-2.822-1.807-5.283-4.294-6.203a2.204 2.204 0 1 0-4.32-.013 6.4 6.4 0 0 0-2.318 1.436 6.4 6.4 0 0 0-1.971 4.642v3.938a.255.255 0 0 1-.255.255c-1.19 0-2.207.897-2.316 2.039a2.26 2.26 0 0 0 2.248 2.477h3.89A2.91 2.91 0 0 0 12 22a2.91 2.91 0 0 0 2.884-2.58h3.89c.636 0 1.246-.272 1.671-.74a2.29 2.29 0 0 0 .578-1.738c-.11-1.142-1.129-2.039-2.316-2.039a.253.253 0 0 1-.255-.255M12 3.29c.504 0 .913.41.913.913 0 .042-.006.08-.013.123a6 6 0 0 0-.664-.062 6.7 6.7 0 0 0-1.136.065c-.006-.042-.013-.08-.013-.123 0-.506.41-.916.913-.916m0 17.42a1.62 1.62 0 0 1-1.58-1.29h3.161a1.62 1.62 0 0 1-1.58 1.29"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-notification-active_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 2h20v20H2z"
  })))));
};
export default SvgIconNotificationActive;